module.exports = __webpack_public_path__ + "static/media/SubscriptionActive.673a09f9.svg";